import {
  getUserUnreadNotificationCount,
  getUserNotifications,
  markUserNotificationAsRead,
} from '@/api/notification.api'

const state = {
  unreadCount: 0,
  isUnreadCountActive: null,
  notificationsPage: 1,
  notifications: []
}

const mutations = {
  setUnreadNotificationCount: (state, count) => state.unreadCount = count,

  addNotification: (state, notification) => state.notifications.push(notification),

  decreaseNotificationCount: (state) => !state.unreadCount || state.unreadCount--,

  markNotificationAsRead: (state, notification) => {
    const index = state.notifications.findIndex(n => notification.id == n.id)
    state.notifications[index].is_unread = false
  },

  resetNotificaitons: (state) => {
    state.notifications = []
    state.notificationsPage = 1
  }
}

const getters = {
  unreadNotificationCount: ({ unreadCount }) => unreadCount,

  notifications: ({ notifications }) => notifications,

  isLastNotificationsPage: ({ notificationsPage }) => notificationsPage === null
}

const actions = {
  fetchUnreadNotificationCount ({ state, commit }) {
    if (state.isUnreadCountActive) {
      return
    }

    const fetch = async () => {
      const res = await getUserUnreadNotificationCount()
      commit('setUnreadNotificationCount', res.data.count)
    }

    fetch()
    setInterval(() => fetch() , 120000)
    
    this.isUnreadCountActive = true
  },

  async fetchNotifications ({ getters, commit, state }) {
    if (getters.isLastNotificationsPage) {
      return
    }

    const res = await getUserNotifications({ page: state.notificationsPage++ })
    res.data.data.map(notification => commit('addNotification', notification))

    if (!res.data.links.next) {
      state.notificationsPage = null
    }
  },

  async markNotificationAsRead ({ commit }, notification) {
    commit('decreaseNotificationCount')
    commit('markNotificationAsRead', notification)

    await markUserNotificationAsRead(notification.id)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
